import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { urlManager } from '../../../Utils/URL/URLManager';

interface Props {}

const AdminPage: React.FC<Props> = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(urlManager.admin().users());
  }, [navigate]);

  return null;
};

export default AdminPage;
